import styled from 'styled-components';
import { media } from 'src/assets/_responsive-mixin';

export const StickyFormHeader = styled.div`
  position: sticky;
  top: 60px;
  background: var(--content-background);
  z-index: 10;
  box-shadow: 0 1px 4px -2px rgba(0, 0, 0, 0.16);

  padding: 8px 128px;
  margin: 0 -128px;
  margin-bottom: 32px;

  ${media.xlarge`
    padding: 8px 64px;
    margin: 0 -64px;
    margin-bottom: 32px;
  `}

  ${media.small`
    padding: 8px 16px;
    margin: 0 -16px;
    margin-bottom: 32px;
  `}
`;
